import imagePreview from './index'

imagePreview.install = (Vue) => {
  Vue.prototype.$brbImagePreview = imagePreview
}

export default imagePreview
